import request from '@/plugins/http'

export function messageListApi(param) {
    return request.post('/api/admin/message/list', param);
}

export function messageDeleteApi(param) {
    return request.post('/api/admin/message/delete', param);
}

